import React, { useState } from "react";
import Popover from "react-popover";
import { Box, Text } from "grommet";
import { useTranslation } from "react-i18next";

export default function ConcurrentBookingsIcon({ pkey }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Popover
      key={pkey}
      isOpen={open}
      body={t("doorsDialog.concurrentBookingsHelp")}
      children={
        <Box
          key={pkey}
          onMouseOver={() => setOpen(true)}
          onMouseOut={() => setOpen(false)}
          background="status-ok"
          round
          width={{ min: "20px" }}
          align="center"
          justify="center"
        >
          <Text color="white" size="xsmall">
            M
          </Text>
        </Box>
      }
    />
  );
}